<div class="modal-header">
    <h4 class="modal-title">Inactividad</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)"></button>
</div>
<div class="modal-body">
    <p>Su sesión está a punto de expirar por inactividad.</p>
    <p>En {{timeLeft()}} segundos su sesión cerrará</p>
    <p>¿Desea continuar con su sesión?</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="activeModal.close(true)">Si</button>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">No</button>
</div>